export class NexusAIIdentifiers {
  private static readonly identifier = 'Nexus';

  static get order() {
    return `${this.identifier}.Buy`;
  }

  static get putInCart() {
    return `${this.identifier}.PutInCart`;
  }

  static get actionInTable() {
    return `${this.identifier}.ActionInTable`;
  }

  static get clickPrint() {
    return `${this.identifier}.ClickPrint`;
  }
}
